import {useEffect, useState} from "react";
import {router} from "@inertiajs/react";

export function useInertiaLoader() {
    const [loading, setLoading] = useState(false);
    let timeout;

    useEffect(() => {
        const offStart = router.on('start', () => {
            timeout = setTimeout(() => setLoading(true), 150);
        });

        const offFinish = router.on('finish', () => {
            clearTimeout(timeout);
            setLoading(false);
        });

        const offError = router.on('error', () => {
            clearTimeout(timeout);
            setLoading(false);
        });

        return () => {
            offStart();
            offFinish();
            offError();
        };
    }, []);

    return loading;
}
